var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [
        _c(
          "div",
          {
            staticClass: "d-flex align-center flex-wrap"
          },
          [
            _c(
              "span",
              {
                staticClass: "mr-auto"
              },
              [_vm._v(_vm._s(_vm.title))]
            ),
            _vm._t("header-actions")
          ],
          2
        )
      ]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-data-table",
            _vm._b(
              {
                scopedSlots: _vm._u([
                  {
                    key: "item.actions",
                    fn: function fn(_ref) {
                      var item = _ref.item
                      return [
                        _c(
                          "gg-btn",
                          {
                            attrs: {
                              color: "primary",
                              elevation: "0"
                            },
                            on: {
                              click: function click($event) {
                                return _vm.triggerModel(
                                  item.dest,
                                  item.forward,
                                  item.type
                                )
                              }
                            }
                          },
                          [_vm._v(" Delete ")]
                        )
                      ]
                    }
                  }
                ])
              },
              "v-data-table",
              _vm.tableProps,
              false
            )
          ),
          [
            _c("gg-modal", {
              attrs: {
                "is-active": _vm.emailDialog
              },
              on: {
                close: _vm.triggerEmailModal
              },
              scopedSlots: _vm._u([
                {
                  key: "toolbar",
                  fn: function fn() {
                    return [_vm._v(" Delete Forwarder? ")]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function fn() {
                    return [
                      _vm._v(
                        " Are you sure you want to delete the email forwarder “" +
                          _vm._s(_vm.model.dest) +
                          "” to “" +
                          _vm._s(_vm.model.forward) +
                          "”? "
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function fn() {
                    return [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: ""
                          },
                          on: {
                            click: _vm.triggerEmailModal
                          }
                        },
                        [_vm._v(" Cancel ")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            primary: "",
                            loading: _vm.pending
                          },
                          on: {
                            click: _vm.deleteEmailForwarder
                          }
                        },
                        [_vm._v(" Delete ")]
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          [
            _c("gg-modal", {
              attrs: {
                "is-active": _vm.domainDialog
              },
              on: {
                close: _vm.triggerDomainModal
              },
              scopedSlots: _vm._u([
                {
                  key: "toolbar",
                  fn: function fn() {
                    return [_vm._v(" Delete Forwarder? ")]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function fn() {
                    return [
                      _vm._v(
                        " Are you sure you want to delete the domain forwarder “" +
                          _vm._s(_vm.model.dest) +
                          "” to “" +
                          _vm._s(_vm.model.forward) +
                          "”? "
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function fn() {
                    return [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: ""
                          },
                          on: {
                            click: _vm.triggerDomainModal
                          }
                        },
                        [_vm._v(" Cancel ")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            primary: "",
                            loading: _vm.pending
                          },
                          on: {
                            click: _vm.deleteDomainForwarder
                          }
                        },
                        [_vm._v(" Delete ")]
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }